import React from 'react';
import { __t } from '../../../../../../base/utils/t';
import { VacancyData as VacancyDataProps } from '../../../api/interfaces';
import { Location } from '../../../../../../base/components/Location';
import { Rate } from '../../../../../../base/components/Rate';
import { Currency } from '../../../../../../base/interfaces/config';

import './styles.scss';

interface Props extends VacancyDataProps {
    currencies: Currency[];
    markNewResponseAsReadHandler: () => void;
}

export const VacancyData = ({
    id,
    name,
    rateType,
    currencyId,
    rateFrom,
    rateTo,
    isActive,
    city,
    url,
    currencies,
    markNewResponseAsReadHandler,
}: Props) => {
    return (
        <div className={`responses-table-vacancy-data ${!isActive ? 'responses-table-vacancy-data--inactive' : ''}`}>
            <div className='responses-table-vacancy-data__name-id-wrap'>
                <a
                    href={url}
                    target='_blank'
                    className='responses-table-vacancy-data__name'
                    rel='noreferrer'
                    onClick={markNewResponseAsReadHandler}
                >
                    {name}
                </a>
                <span className='responses-table-vacancy-data__id'>&nbsp;·&nbsp;{`${__t('ID')}:${id}`}</span>
                {!isActive && <div className='responses-table-vacancy-data__archive-label'>{__t('Архив')}</div>}
            </div>
            <div className='responses-table-vacancy-data__location-rate-wrap'>
                <Location
                    flag={city.country?.flag || ''}
                    city={city.name}
                    className='responses-table-vacancy-data__location'
                />
                <Rate
                    rateFrom={rateFrom}
                    rateTo={rateTo}
                    currencyId={currencyId}
                    rateType={rateType}
                    currencies={currencies}
                />
            </div>
        </div>
    );
};
